// extracted by mini-css-extract-plugin
export default {"organisationForm":"OrganisationForm_organisationForm__T0RGT","buttons":"OrganisationForm_buttons__Qk6hm"};